<!-- Filter Card -->
<mat-card>
  <h2 translate>request.panel.title.label</h2>
  <p>{{ subtitle }}</p>

  <mat-card-content>
    <form [formGroup]="searchDataForm" class="search__card-form">
      <div fxFlex fxLayout="row wrap">
        <scf-custom-select-search
          fxFlex="30"
          fxFlex.gt-sm="1 0 auto"
          appearance="outline"
          formControlName="state"
          [id]="'stateSearchPanel'"
          [dataInput]="statusRequests"
          [placeholder]="'request.search.label.state'"
          [hasToTranslateValue]="true"
          [isRequired]="true"
          [showErrors]="searchDataForm?.controls?.state?.errors"
          (selectionChange)="stateSearchPanelChange()"
        ></scf-custom-select-search>
        <mat-form-field fxFlex="30" fxFlex.gt-sm="25" appearance="outline" monthYearFullDirective>
          <mat-label translate>request.search.label.initialDate</mat-label>
          <input
            #inputInitialDate
            id="initialDateSearchPanel"
            matInput
            [matDatepicker]="datepickerInitialDate"
            formControlName="initialDate"
            [min]="minDate"
            [max]="currentDate"
            autocomplete="off"
          />
          <mat-datepicker-toggle matSuffix [for]="datepickerInitialDate"></mat-datepicker-toggle>
          <mat-datepicker
            id="startDateSearchPanel"
            startView="multi-year"
            #datepickerInitialDate
            (monthSelected)="pickerDatesHandler($event, inputInitialDate, datepickerInitialDate)"
            (yearSelected)="pickerDatesHandler($event, inputInitialDate)"
          ></mat-datepicker>
          <mat-error *ngIf="searchDataForm.controls.initialDate.errors?.dateFuture" translate>
            field.error.dateFuture
          </mat-error>
          <mat-error *ngIf="searchDataForm.errors?.dateInvalid" translate>field.error.dateInitial</mat-error>
        </mat-form-field>
        <mat-form-field fxFlex="30" fxFlex.gt-sm="25" appearance="outline" monthYearFullDirective>
          <mat-label translate>request.search.label.finalDate</mat-label>
          <input
            #inputFinalDate
            id="finalDateSearchPanel"
            matInput
            [matDatepicker]="datepickerFinalDate"
            formControlName="finalDate"
            [max]="currentDate"
            [min]="searchDataForm.controls.initialDate?.value"
            autocomplete="off"
          />
          <mat-datepicker-toggle matSuffix [for]="datepickerFinalDate"></mat-datepicker-toggle>
          <mat-datepicker
            id="finalDateDatepickerSearchPanel"
            startView="multi-year"
            #datepickerFinalDate
            (monthSelected)="pickerDatesHandler($event, inputFinalDate, datepickerFinalDate)"
            (yearSelected)="pickerDatesHandler($event, inputFinalDate)"
          ></mat-datepicker>
          <mat-error *ngIf="searchDataForm.controls.finalDate.errors?.dateFuture" translate>
            field.error.dateFuture
          </mat-error>
          <mat-error *ngIf="searchDataForm.errors?.dateInvalid" translate>field.error.dateFinal</mat-error>
        </mat-form-field>

        <div fxFlex="50" fxFlex.gt-sm="35">
          <mat-form-field fxFlex="100" appearance="outline">
            <mat-label translate>operationSearch.operationNumber</mat-label>
            <input
              id="operationNumberOperationSearch"
              #operationNumber
              #operationNumberOperationSearch
              formControlName="operationNumber"
              (keypress)="numberOnly($event, operationNumber)"
              (keyup)="onKeyUp()"
              matInput
              type="search"
              autocomplete="off"
            />
          </mat-form-field>
        </div>
        <div fxFlex="50" fxFlex.gt-sm="35">
          <mat-form-field fxFlex="100" appearance="outline">
            <mat-label translate>search.input.documentId</mat-label>
            <input
              id="nifNieOperationSearch"
              #nifNieOperationSearch
              formControlName="nifNie"
              (keyup)="onKeyUp()"
              matInput
              maxlength="9"
              autocomplete="off"
            />
          </mat-form-field>
        </div>
        <button
          id="searchRequestSearchPanel"
          mat-flat-button
          type="button"
          color="accent"
          class="search__button--request"
          (click)="onSearchClick()"
        >
          <span>{{ 'request.button.consult' | translate | uppercase }}</span>
        </button>
      </div>
    </form>
  </mat-card-content>
</mat-card>
<scf-request-panel
  *ngFor="let operations of operationsByStateList"
  [isMainPanel]="true"
  [state]="setState(operations.idStatus)"
  [isSpecificSearch]="true"
  [specificSearchOperations]="operations.operations"
  (viewRequest)="keepFilterSearch()"
  (keepSearch)="keepFilterSearch()"
  class="operation-search__panel"
>
</scf-request-panel>
